module.exports = __webpack_public_path__ + "img/amazon.ad2eada2.svg";